enum Width {
  EPISODE = 750,
  EPISODE_LIST = 750,
  STATIC = 750,
  DEFAULT = 980,
}

export default Width
